import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { useIntl } from "react-intl";

interface Props {
  alt?: string;
  role?: string;
  fetchPriority?: string;
  loading?: string;
}
const MissingProductImage = ({ alt, role, fetchPriority, loading }: Props) => {
  const { locale } = useIntl();
  if (locale === 'en') {
    return (
      <StaticImage
        src="../../../images/icon-product-image-not-available-en.png"
        alt={alt ?? "Missing product image"}
        role={role}
        fetchPriority={fetchPriority}
        loading={loading}
      />
    );
  }
  return (
    <StaticImage
      src="../../../images/icon-product-image-not-available-fr.png"
      alt={alt ?? "Image de produit manquante"}
      role={role}
      fetchPriority={fetchPriority}
      loading={loading}
    />
  );
};

export default MissingProductImage;
